if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
      this.productWrapper = this.closest('.thb-product-detail');
      if (this.productWrapper) {
        this.productSlider = this.productWrapper.querySelector('.product-images') ? this.productWrapper.querySelector('.product-images') : this.productWrapper.querySelector('.product-quick-images');
        this.thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');
        this.hideVariants = this.productSlider.dataset.hideVariants === 'true';
      }
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }
      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.option_keys = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
          this.option_keys.push(fieldset.querySelector('select').name);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
          this.option_keys.push(fieldset.querySelector('input').name);
        }
      });
      this.dataset.options = this.options;
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value="${option}"]`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      if (!this.productSlider) return;
      let mediaId = `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      let activeMedia = this.productSlider.querySelector(mediaId);

      if (this.thumbnails) {
        this.setActiveMediaSlider(mediaId, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.productSlider);
      } else {
        this.setActiveMedia(activeMedia);
      }

    }
    setActiveMedia(activeMedia) {

      this.productSlider.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });

      this.setImageSetMedia();

      activeMedia.classList.add('is-active');

      activeMedia.parentElement.prepend(activeMedia);

      if (!this.sticky) {
        window.setTimeout(() => {
          if (window.innerWidth > 1068) {
            const rect = activeMedia.parentElement.getBoundingClientRect();
            const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
            const targetY = window.scrollY + rect.top - headerHeight;
            window.scrollTo({
              left: 0,
              top: Math.max(0, targetY),
              behavior: 'instant'
            });
          }
          activeMedia.parentElement.scrollTo({
            left: 0,
            behavior: 'instant'
          });
        });
      }
    }
    setActiveMediaSlider(mediaId, thumbId, productSlider) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);

      if (flkty && this.hideVariants) {
        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });
        if (this.thumbnails) {
          if (this.thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            this.thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(this.thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });
        }

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (this.thumbnails) {
          let activeThumb = this.thumbnails.querySelector(thumbId);

          activeThumb.classList.add('is-active');
          activeThumb.classList.add('is-initial-selected');
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);

      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.textContent = window.theme.variantStrings.addToCart;
          }
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();


      if (variant_data) {
        let selected_options = false;
        if (this.currentVariant) {
          selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });
        } else {
          let found_option = variant_data.find(option => {
            return option.option1 === this.options[0];
          });
          if (found_option) {
            selected_options = [
              {
                "value": this.options[0],
                "index": "option1"
              },
              {
                "value": found_option.option2,
                "index": "option2"
              }
            ];
          } else {
            return;
          }
        }

        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }

    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }
      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productSlider.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);

      if (this.hideVariants) {
        if (this.thumbnails) {
          // Product images
          this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });
          selected_set_images.forEach(thumb => {
            thumb.classList.toggle('is-active', thumb.dataset.group === group);
          });

          // Product thumbnails
          this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });
          selected_set_thumbs.forEach(thumb => {
            thumb.classList.toggle('is-active', thumb.dataset.group === group);
          });
        } else {
          // Product images
          this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });
          selected_set_images.forEach(thumb => {
            if (thumb.dataset.group === group) {
              thumb.classList.add('is-active');
            }
          });
        }

      } else {

        if (!this.thumbnails) {
          let set_images = Array.from(selected_set_images).filter(function (element) {
            return element.dataset.group === group;
          });
          set_images.forEach(thumb => {
            thumb.parentElement.prepend(thumb);
          });
        }

      }
      if (!this.thumbnails) {
        setTimeout(() => {
          this.productSlider.querySelector('product-slider').onPaginationResize();
        }, 100);
      }

      /* Cor trocada: o vídeo da cor nova volta ao início.

         Num quadro depois da troca, de propósito. As classes acabaram de mudar e
         o navegador ainda não recalculou o layout — medir "está na tela?" agora
         devolveria o estado antigo, e o vídeo certo ficaria pausado. */
      const slider = this.productSlider && this.productSlider.querySelector('product-slider');
      if (slider && typeof slider.restartGalleryVideos === 'function') {
        requestAnimationFrame(() => slider.restartGalleryVideos());
      }
    }

    createAvailableOptionsTree(variants, currentlySelectedValues) {
      // Reduce variant array into option availability tree
      return variants.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = { value: variant[index], isUnavailable: true };
            options[index].push(entry);
          }

          const currentOption1 = currentlySelectedValues.find(({ value, index }) => index === 'option1');
          const currentOption2 = currentlySelectedValues.find(({ value, index }) => index === 'option2');

          switch (index) {
            case 'option1':
              // Option1 inputs should always remain enabled based on all available variants
              entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              break;
            case 'option2':
              // Option2 inputs should remain enabled based on available variants that match first option group
              if (currentOption1 && variant.option1 === currentOption1.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
              break;
            case 'option3':
              // Option 3 inputs should remain enabled based on available variants that match first and second option group
              if (currentOption1 && variant.option1 === currentOption1.value && currentOption2 && variant.option2 === currentOption2.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
          }
        });

        return options;
      }, { option1: [], option2: [], option3: [] });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /* Ícones dos controles de vídeo — usados tanto na galeria quanto no popup,
     por isso ficam aqui fora e não duplicados nos dois lugares. */
  const VIDEO_ICONS = {
    play: '<svg viewBox="0 0 24 24" width="17" height="17" fill="currentColor"><path d="M8 5.2v13.6L19 12z"/></svg>',
    pause: '<svg viewBox="0 0 24 24" width="17" height="17" fill="currentColor"><path d="M8 5h3.2v14H8zM12.8 5H16v14h-3.2z"/></svg>',
    on: '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9.5v5h3.5L12 18V6L7.5 9.5H4z"/><path d="M15.5 9.8a3 3 0 0 1 0 4.4"/><path d="M18 7.5a6.2 6.2 0 0 1 0 9"/></svg>',
    off: '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9.5v5h3.5L12 18V6L7.5 9.5H4z"/><path d="M16 10l4.5 4.5M20.5 10L16 14.5"/></svg>',
    close: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    expand: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M9 4H5a1 1 0 0 0-1 1v4M15 4h4a1 1 0 0 1 1 1v4M9 20H5a1 1 0 0 1-1-1v-4M15 20h4a1 1 0 0 0 1-1v-4"/></svg>'
  };

  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.pagination = this.parentElement.querySelector('.product-images-buttons');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      // Start Gallery
      let observer = new MutationObserver(() => {
        this.setupProductGallery();
      });

      observer.observe(this, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        characterData: false
      });

      this.setupProductGallery();
      this.setupGalleryVideos();

      // Start Pagination
      if (this.pagination) {
        this.setupPagination();
        this.resizeObserver = new ResizeObserver(entries => this.onPaginationResize());
        this.resizeObserver.observe(this);
        this.addEventListener('scroll', this.updatePagination.bind(this));
      }
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }

      this.setEventListeners();
    }
    /*
      Popup do vídeo no formato de celular (9:16), com controles próprios.

      Usa um <video> novo com a mesma fonte em vez de mover o original: mover um
      vídeo de lugar no DOM interrompe a reprodução em vários navegadores. O
      tempo atual é transferido, e ao fechar o original volta a tocar de onde
      parou.

      Os controles são desenhados aqui, e não os do navegador, porque o player
      nativo muda de cara em cada sistema e não acompanha a identidade da loja.
    */
    openVideoModal(sourceVideo) {
      const source = sourceVideo.querySelector('source');
      const src = (source && source.src) || sourceVideo.currentSrc || sourceVideo.src;
      if (!src) return;

      const icon = VIDEO_ICONS;

      const modal = document.createElement('div');
      modal.className = 'product-video-modal';
      modal.innerHTML =
        '<button type="button" class="product-video-modal__close" aria-label="Fechar">' + icon.close + '</button>' +
        '<div class="product-video-modal__frame">' +
          '<div class="pv-bar">' +
            '<button type="button" class="pv-bar__btn pv-bar__toggle" aria-label="Pausar">' + icon.pause + '</button>' +
            '<div class="pv-bar__track"><span class="pv-bar__fill"></span></div>' +
            '<span class="pv-bar__time">0:00</span>' +
            '<button type="button" class="pv-bar__btn pv-bar__sound" aria-label="Ativar som">' + icon.off + '</button>' +
          '</div>' +
        '</div>';

      const frame = modal.querySelector('.product-video-modal__frame');
      const toggle = modal.querySelector('.pv-bar__toggle');
      const track = modal.querySelector('.pv-bar__track');
      const fill = modal.querySelector('.pv-bar__fill');
      const timeEl = modal.querySelector('.pv-bar__time');
      const sound = modal.querySelector('.pv-bar__sound');

      const startAt = sourceVideo.currentTime;
      const video = document.createElement('video');
      video.src = src;
      video.playsInline = true;
      video.loop = true;
      /* Herda o estado do som da galeria: se a pessoa já tinha ligado o áudio
         ali, o popup abre com som — e vice-versa. */
      video.muted = sourceVideo.muted;
      sound.innerHTML = video.muted ? icon.off : icon.on;
      sound.setAttribute('aria-label', video.muted ? 'Ativar som' : 'Desativar som');
      frame.insertBefore(video, frame.firstChild);

      const clock = (seconds) => {
        if (!isFinite(seconds)) return '0:00';
        const min = Math.floor(seconds / 60);
        const rest = Math.floor(seconds % 60);
        return min + ':' + (rest < 10 ? '0' : '') + rest;
      };

      video.addEventListener('loadedmetadata', () => {
        try { video.currentTime = startAt; } catch (e) { /* fora de alcance */ }
        const attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
      }, { once: true });
      video.addEventListener('timeupdate', () => {
        fill.style.width = (video.duration ? (video.currentTime / video.duration) * 100 : 0) + '%';
        timeEl.textContent = clock(video.currentTime);
      });
      video.addEventListener('play', () => {
        toggle.innerHTML = icon.pause;
        toggle.setAttribute('aria-label', 'Pausar');
      });
      video.addEventListener('pause', () => {
        toggle.innerHTML = icon.play;
        toggle.setAttribute('aria-label', 'Reproduzir');
      });

      toggle.addEventListener('click', () => {
        if (video.paused) {
          const attempt = video.play();
          if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
        } else {
          video.pause();
        }
      });
      sound.addEventListener('click', () => {
        video.muted = !video.muted;
        sound.innerHTML = video.muted ? icon.off : icon.on;
        sound.setAttribute('aria-label', video.muted ? 'Ativar som' : 'Desativar som');
      });
      track.addEventListener('click', (event) => {
        const box = track.getBoundingClientRect();
        const ratio = Math.min(1, Math.max(0, (event.clientX - box.left) / box.width));
        if (video.duration) video.currentTime = ratio * video.duration;
      });
      video.addEventListener('click', () => toggle.click());

      sourceVideo.pause();
      document.body.appendChild(modal);
      const previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';

      const close = () => {
        document.removeEventListener('keydown', onKey);
        video.pause();
        modal.remove();
        document.body.style.overflow = previousOverflow;
        const attempt = sourceVideo.play();
        if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
      };
      const onKey = (event) => {
        if (event.key === 'Escape') close();
      };

      /* Fecha no fundo escuro e no X; cliques dentro do quadro vão para os controles. */
      modal.addEventListener('click', (event) => {
        if (event.target === modal || event.target.closest('.product-video-modal__close')) close();
      });
      document.addEventListener('keydown', onKey);
      modal.querySelector('.product-video-modal__close').focus();
    }
    /*
      Vídeos da galeria: tocam sozinhos, mudos, em loop e sem player nativo.
      Clicar em qualquer ponto do vídeo abre o popup, tanto no desktop quanto
      no mobile — assim os controles do navegador nunca aparecem.
    */
    /* Volta os vídeos da galeria ao início.

       Um <video> guarda o ponto em que estava mesmo enquanto o slide dele fica
       escondido. Ao trocar a cor da variante, o slide da cor nova aparece com o
       vídeo no tempo em que o da cor anterior parou — às vezes já no fim, e o
       cliente vê o encerramento antes do começo.

       Zera todos e toca de novo só os que estão realmente na tela: um vídeo em
       slide escondido tocando à toa gasta banda e bateria sem ninguém ver. */
    restartGalleryVideos() {
      const videos = this.querySelectorAll('.product-single__media-native-video video');
      if (!videos.length) return;

      videos.forEach((video) => {
        try {
          video.pause();
          video.currentTime = 0;
        } catch (e) { /* metadados ainda não carregaram; o loadedmetadata resolve */ }

        const slide = video.closest('.product-images__slide') || video.closest('[data-media-id]');
        /* offsetParent nulo cobre o slide escondido por display:none, que é como
           o filtro de cor esconde o que não pertence à variante escolhida. */
        const naTela = slide ? slide.offsetParent !== null : true;
        if (!naTela) return;

        const attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
      });
    }

    setupGalleryVideos() {
      const videos = this.querySelectorAll('.product-single__media-native-video video');
      if (!videos.length) return;

      videos.forEach((video) => {
        if (video.dataset.galleryVideoBound === 'true') return;
        video.dataset.galleryVideoBound = 'true';

        /* Propriedades além dos atributos: alguns navegadores só respeitam o
           mudo pela propriedade, e sem mudo o autoplay é bloqueado. */
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.loop = true;
        video.removeAttribute('controls');

        const play = () => {
          const attempt = video.play();
          if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
        };
        play();
        video.addEventListener('canplay', play, { once: true });
        /* Rede de segurança: se por algum motivo o loop não pegar, reinicia. */
        video.addEventListener('ended', () => {
          video.currentTime = 0;
          play();
        });

        /* No celular a galeria é um carrossel: o vídeo só deve rodar quando o
           slide dele está em cena, e sempre do começo. Sem isto ele roda desde
           o carregamento e, quando a pessoa chega no slide, já está no meio.

           O observador vale nas duas faixas — no desktop os slides ficam todos
           visíveis, então ele simplesmente não desliga nada. */
        const slideDoVideo = video.closest('.product-images__slide') || video.closest('[data-media-id]');
        if (slideDoVideo && typeof IntersectionObserver === 'function') {
          new IntersectionObserver((entradas) => {
            entradas.forEach((entrada) => {
              if (entrada.isIntersecting) {
                if (video.currentTime > 0.3) video.currentTime = 0;
                const t = video.play();
                if (t && typeof t.catch === 'function') t.catch(() => {});
              } else {
                video.pause();
                try { video.currentTime = 0; } catch (e) {}
              }
            });
          }, { threshold: 0.6 }).observe(slideDoVideo);
        }

        const stage = video.closest('.product-single__media') || video;
        stage.classList.add('product-video-stage');

        const hint = document.createElement('span');
        hint.className = 'product-video-hint';
        hint.setAttribute('aria-hidden', 'true');
        hint.innerHTML = VIDEO_ICONS.expand;
        stage.appendChild(hint);

        /* Play/pause e som direto na galeria, no hover. Só no desktop — no
           mobile não existe hover e o toque já abre o popup, que tem os seus. */
        const mini = document.createElement('div');
        mini.className = 'product-video-mini';
        mini.innerHTML =
          '<button type="button" class="product-video-mini__btn" data-act="toggle" aria-label="Pausar">' +
          VIDEO_ICONS.pause + '</button>' +
          '<button type="button" class="product-video-mini__btn" data-act="sound" aria-label="Ativar som">' +
          VIDEO_ICONS.off + '</button>';
        stage.appendChild(mini);

        const toggleBtn = mini.querySelector('[data-act="toggle"]');
        const soundBtn = mini.querySelector('[data-act="sound"]');

        video.addEventListener('play', () => {
          toggleBtn.innerHTML = VIDEO_ICONS.pause;
          toggleBtn.setAttribute('aria-label', 'Pausar');
        });
        video.addEventListener('pause', () => {
          toggleBtn.innerHTML = VIDEO_ICONS.play;
          toggleBtn.setAttribute('aria-label', 'Reproduzir');
        });

        mini.addEventListener('click', (event) => {
          const button = event.target.closest('.product-video-mini__btn');
          if (!button) return;
          /* Impede que o clique suba para o stage e abra o popup. */
          event.preventDefault();
          event.stopPropagation();

          if (button.dataset.act === 'toggle') {
            if (video.paused) play();
            else video.pause();
            return;
          }
          video.muted = !video.muted;
          soundBtn.innerHTML = video.muted ? VIDEO_ICONS.off : VIDEO_ICONS.on;
          soundBtn.setAttribute('aria-label', video.muted ? 'Ativar som' : 'Desativar som');
        });

        stage.addEventListener('click', (event) => {
          event.preventDefault();
          this.openVideoModal(video);
        });
      });
    }
    buildItems(activeImages) {
      let images = activeImages.map((item) => {
        let activelink = item.querySelector('.product-single__media-zoom');
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          title: activelink.getAttribute('title')
        };
      });
      return images;
    }
    /*
      Slides de imagem que devem entrar no lightbox.

      O filtro por clientWidth existe para descartar os slides escondidos por
      variante (hide_variants). O limite de miniaturas da galeria também usa
      display:none, mas essas imagens PRECISAM aparecer no lightbox — por isso
      o limite é removido, a medição é feita e ele volta na mesma execução,
      sem repintar a tela.
    */
    visibleImageSlides() {
      const container = this.closest('.product-image-container');
      const limited = container && container.classList.contains('is-media-limited');
      if (limited) container.classList.remove('is-media-limited');
      const list = Array.from(this.querySelectorAll('.product-images__slide--image')).filter(element => element.clientWidth > 0);
      if (limited) container.classList.add('is-media-limited');
      return list;
    }
    /* Quantos slides estão à mostra x quantos existem no total. */
    mediaLimitState() {
      const container = this.closest('.product-image-container');
      if (!container || !container.classList.contains('is-media-limited')) return null;
      const shown = Array.from(this.querySelectorAll('.product-images__slide--image')).filter(element => element.clientWidth > 0);
      return { container: container, shown: shown, all: this.visibleImageSlides() };
    }
    /* Recalcula se o botão deve aparecer, a partir do estado atual da galeria. */
    refreshMediaLimitButton() {
      const state = this.mediaLimitState();
      if (!state) return null;
      const button = state.container.querySelector('.product-media-more');
      if (!button) return null;
      button.hidden = (state.all.length - state.shown.length) <= 0;
      return button;
    }
    setupMediaLimit() {
      const button = this.refreshMediaLimitButton();
      if (!button) return;
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';

      button.addEventListener('click', (event) => {
        event.preventDefault();
        const current = this.mediaLimitState();
        if (!current) return;
        const firstHidden = current.all[current.shown.length];
        if (!firstHidden) return;
        const link = firstHidden.querySelector('.product-single__media-zoom');
        if (!link) return;
        /* Revela para o PhotoSwipe conseguir medir o slide, abre e esconde de
           novo — tudo síncrono, então a grade não pisca. */
        current.container.classList.remove('is-media-limited');
        link.click();
        current.container.classList.add('is-media-limited');
      });

      /*
        O filtro por cor (setImageSetMedia) troca a classe is-active nos SLIDES,
        que são descendentes. O observer do slider só vigia o próprio elemento,
        então sem isso a contagem do botão congelaria no estado do carregamento
        e não acompanharia a troca de variante.

        Só observa atributo (não childList), então o clone dos links de zoom
        feito em setEventListeners não dispara nada. E o botão fica fora de
        `this`, então mexer nele também não realimenta o observer.
      */
      let pending = false;
      this.mediaLimitObserver = new MutationObserver(() => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(() => {
          pending = false;
          this.refreshMediaLimitButton();
        });
      });
      this.mediaLimitObserver.observe(this, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });

      /* Cruzar o breakpoint muda quantos slides ficam escondidos, e isso não
         mexe em classe nenhuma — o observer acima não veria. */
      let resizeTimer = null;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => this.refreshMediaLimitButton(), 150);
      });
    }
    setEventListeners() {
      let activeImages = this.visibleImageSlides(),
        items = this.buildItems(activeImages),
        captionEl = this.dataset.captions,
        pswpElement = document.querySelectorAll('.pswp')[0],
        options = {
          maxSpreadZoom: 2,
          loop: false,
          allowPanToNext: false,
          closeOnScroll: false,
          showHideOpacity: false,
          arrowKeys: true,
          history: false,
          captionEl: captionEl,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: true,
          arrowEl: true,
          preloaderEl: true
        };

      let openPswp = function (e, link, options, pswpElement, items) {
        let parent = link.closest('.product-images__slide');
        let i = activeImages.indexOf(parent);
        options.index = parseInt(i, 10);
        options.getThumbBoundsFn = () => {
          const thumbnail = link.closest('.product-single__media'),
            pageYScroll = window.scrollY || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        };
        if (typeof PhotoSwipe !== 'undefined') {
          let pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

          // ── Helpers ──────────────────────────────────────────────
          let titleEl   = pswpElement.querySelector('.pswp__product-info__title');
          let variantEl = pswpElement.querySelector('.pswp__product-info__variant');
          let thumbsEl  = pswpElement.querySelector('.pswp__thumbs');

          // Populate product title
          if (titleEl) {
            let productTitle = document.querySelector('.product-title');
            titleEl.textContent = productTitle ? productTitle.textContent.trim() : '';
          }

          // Build thumbnail strip — usando width=150 em vez de width=20 (placeholder)
          if (thumbsEl) {
            thumbsEl.innerHTML = '';
            items.forEach(function(item, i) {
              let btn = document.createElement('button');
              btn.className = 'pswp__thumb';
              let thumbSrc = (item.msrc || '').replace(/width=\d+/, 'width=150');
              btn.style.backgroundImage = 'url(' + thumbSrc + ')';
              btn.setAttribute('aria-label', 'Ir para imagem ' + (i + 1));
              btn.addEventListener('click', function() { pswp.goTo(i); });
              thumbsEl.appendChild(btn);
            });
          }

          function updateActive() {
            let idx = pswp.getCurrentIndex();

            // Highlight active thumb + scroll apenas dentro do container de thumbs
            if (thumbsEl) {
              let thumbBtns = thumbsEl.querySelectorAll('.pswp__thumb');
              thumbBtns.forEach(function(t, i) {
                t.classList.toggle('is-active', i === idx);
              });
              // Scroll o container de thumbs (não a página) para centralizar no ativo
              let activeBtn = thumbBtns[idx];
              if (activeBtn) {
                let btnLeft    = activeBtn.offsetLeft;
                let btnWidth   = activeBtn.offsetWidth;
                let contWidth  = thumbsEl.offsetWidth;
                let targetScroll = btnLeft - (contWidth / 2) + (btnWidth / 2);
                thumbsEl.scrollTo({ left: targetScroll, behavior: 'smooth' });
              }
            }

            // Update variant info
            if (variantEl) {
              let variantSelects = document.querySelector('variant-selects, variant-radios');
              if (variantSelects && variantSelects.dataset.options) {
                variantEl.textContent = variantSelects.dataset.options.split(',').join(' / ');
              } else {
                variantEl.textContent = '';
              }
            }
          }

          pswp.listen('firstUpdate', function() {
            pswp.listen('parseVerticalMargin', function(item) {
              item.vGap = { top: 50, bottom: 100 };
            });
          });

          pswp.listen('afterChange', updateActive);
          pswp.listen('initialZoomIn', updateActive);

          pswp.init();
        }
        e.preventDefault();
      };
      this.querySelectorAll('.product-single__media-zoom').forEach(function (link) {
        let thumbnail = link.closest('.product-single__media');
        let clone = link.cloneNode(true);
        thumbnail.append(clone);
        link.remove();
        clone.addEventListener('click', (e) => openPswp(e, clone, options, pswpElement, items));
        
        // O próprio thumbnail tem a classe product-single__media-image — adicionar listener diretamente
        thumbnail.style.cursor = 'zoom-in';
        thumbnail.addEventListener('click', function(e) {
          // Evitar duplo disparo se o click vier do botão de zoom
          if (e.target.closest('.product-single__media-zoom')) return;
          openPswp(e, clone, options, pswpElement, items);
        });
      });

      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });

      this.setupMediaLimit();
    }
    setupPagination() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

      this.currentPageElement = this.pagination.querySelector('.slider-counter--current');
      this.pageTotalElement = this.pagination.querySelector('.slider-counter--total');
      this.progressBarFill = this.pagination.querySelector('.slider-progress-bar-fill');

      this.prevButton = this.pagination.querySelector('button[name="previous"]');
      this.nextButton = this.pagination.querySelector('button[name="next"]');

      if (this.prevButton) {
        this.prevButton.addEventListener('click', this.onPaginationButtonClick.bind(this));
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', this.onPaginationButtonClick.bind(this));
      }

      this.updatePagination();
    }
    onPaginationResize() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);

      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.updatePagination();
    }
    onPaginationButtonClick(event) {
      event.preventDefault();
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.scrollLeft + (1 * this.sliderItemOffset) : this.scrollLeft - (1 * this.sliderItemOffset);
      this.scrollTo({
        left: this.slideScrollPosition
      });
    }
    updatePagination() {
      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement) {
        this.currentPageElement.textContent = this.currentPage;
      }
      if (this.pageTotalElement) {
        this.pageTotalElement.textContent = this.sliderItemsToShow.length;
      }
      if (this.progressBarFill) {
        const progress = (this.currentPage / this.sliderItemsToShow.length) * 100;
        this.progressBarFill.style.width = `${progress}%`;
      }

      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }

      if (this.prevButton) {
        if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollLeft === 0) {
          this.prevButton.setAttribute('disabled', 'disabled');
        } else {
          this.prevButton.removeAttribute('disabled');
        }
      }

      if (this.nextButton) {
        if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
          this.nextButton.setAttribute('disabled', 'disabled');
        } else {
          this.nextButton.removeAttribute('disabled');
        }
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.scrollLeft;
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.form.reportValidity()) {
        return;
      }
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.notesToggle();
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }
        if (section.id === 'Cart' && typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));



      let product_drawer = document.getElementById('Product-Drawer');
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.querySelector('.product-quick-images--container').classList.remove('active');
        document.body.classList.remove('open-quick-view');

        if (window.innerWidth < 1069) {
          product_drawer.classList.remove('active');
          if (document.getElementById('Cart-Drawer')) {
            document.getElementById('Cart-Drawer').classList.add('active');
            document.body.classList.add('open-cart');
            document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
            dispatchCustomEvent('cart-drawer:open');
          }
        } else {
          product_drawer.querySelector('.product-quick-images--container').addEventListener('transitionend', function () {
            product_drawer.classList.remove('active');

            if (document.getElementById('Cart-Drawer')) {
              document.getElementById('Cart-Drawer').classList.add('active');
              document.body.classList.add('open-cart');
              document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
              dispatchCustomEvent('cart-drawer:open');
            }
          });
        }

        if (!document.getElementById('Cart-Drawer')) {
          document.body.classList.remove('open-cc');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      this.setupObservers();
    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}

/* Smart sticky: when product info column is taller than viewport,
   let it scroll fully before sticking (so the bottom is reachable). */
(function () {
  function calcStickyTop(el) {
    var vh = window.innerHeight;
    var ch = el.offsetHeight;
    var header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 80;
    var safety = 20;
    if (ch + header + safety * 2 > vh) {
      el.style.setProperty('--sticky-top', (vh - ch - safety) + 'px');
    } else {
      el.style.removeProperty('--sticky-top');
    }
  }
  function updateAll() {
    document.querySelectorAll('.product-information--inner.production-information--sticky').forEach(calcStickyTop);
  }
  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateAll, 120);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll);
  } else {
    updateAll();
  }
  window.addEventListener('load', updateAll);
  window.addEventListener('resize', onResize);
  document.addEventListener('shopify:section:load', updateAll);
})();